/**
 * 🚨 `@tiendanube/nube-sdk-ui` needs worker globals that a browser does not have.
 *
 * Every component constructor calls `generateInternalId`, which reads `self.__APP_DATA__.id` to
 * build the component's id. In a Web Worker the host provides that; in the admin iframe `self`
 * exists (it is `window`) but `__APP_DATA__` does not, so the FIRST call throws
 * `Cannot read properties of undefined (reading 'id')` and the whole preview fails to render.
 *
 * Flagged as a Phase 9 prerequisite in `migrationPlan.md` and confirmed here: the preview cannot
 * call `buildCodForm` at all without this.
 *
 * The id only has to be stable and non-empty — it is a namespace for generated ids and class names,
 * and nothing in the admin resolves it against a real app.
 */
const APP_ID = 'cod-preview';

interface WithAppData {
  __APP_DATA__?: { id: string };
}

/** Idempotent. Call before building a tree; safe to call on every render. */
export function ensureSdkGlobals(): void {
  const g = globalThis as typeof globalThis & WithAppData;
  g.__APP_DATA__ ??= { id: APP_ID };
  // Node has no `self`; the browser and the worker both do. Tests run in Node.
  if (!('self' in g)) (g as { self?: unknown }).self = g;
}
